import { useEffect, useState } from "react";
import { UserMinus } from "lucide-react";
import api from "@/lib/api";

const PLAN = { free: "Free", basic_monthly: "Basic", avanzato_monthly: "Avanzato", pro_monthly: "Pro", business_monthly: "Business" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export const AdminDeletedAccounts = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/deleted-accounts").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <div className="rounded-2xl mo-card overflow-hidden" data-testid="admin-deleted-accounts">
      <div className="px-6 py-4 border-b border-gray-100">
        <h3 className="font-display font-semibold text-2xl flex items-center gap-2"><UserMinus className="h-5 w-5 text-red-500" /> Account eliminati</h3>
        <p className="text-sm text-gray-500 mt-0.5">Registro di chi ha cancellato un account: dal ristoratore stesso ("Elimina account") o da te dal pannello.</p>
      </div>
      <div className="p-6">
        {rows === null ? <p className="text-sm text-gray-400">Caricamento…</p> : rows.length === 0 ? <p className="text-sm text-gray-400" data-testid="deleted-empty">Nessuna cancellazione registrata (il registro parte da oggi).</p> : (
          <ul className="divide-y divide-gray-100 text-sm">
            {rows.map((x, i) => (
              <li key={i} className="py-2.5 flex flex-wrap items-center justify-between gap-2" data-testid={`deleted-row-${i}`}>
                <div className="min-w-0">
                  <p className="font-medium truncate">{x.email} <span className="text-gray-400 font-normal">· {PLAN[x.plan] || x.plan}</span></p>
                  <p className="text-xs text-gray-500 truncate">{x.restaurants?.length ? x.restaurants.map((r) => r.name || r.slug).join(", ") : "nessun ristorante"} · iscritto il {fmt(x.user_created_at)}</p>
                  {(x.reason || x.reason_text) && <p className="text-xs text-amber-800 mt-0.5" data-testid={`deleted-reason-${i}`}>Motivo: <strong>{x.reason || "—"}</strong>{x.reason_text && <span className="text-gray-600"> · “{x.reason_text}”</span>}</p>}
                </div>
                <div className="text-right text-xs shrink-0">
                  <p className="font-semibold">{fmt(x.at)}</p>
                  <p className={x.by === "admin" ? "text-amber-700" : "text-gray-500"}>{x.by === "admin" ? `eliminato da admin (${x.admin_email})` : "eliminato dal ristoratore"}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
